"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var toneValueBase = _a.toneValueBase,
      lineHeight = _a.lineHeight,
      colorBorder = _a.colorBorder,
      sizeBorderRadius = _a.sizeBorderRadius,
      colorPrimary = _a.colorPrimary,
      colorBgSecondary = _a.colorBgSecondary,
      sizeControlCheckWidth = _a.sizeControlCheckWidth,
      sizeControlCheckHeight = _a.sizeControlCheckHeight,
      x3 = _a.x3,
      x2 = _a.x2,
      colorIcon = _a.colorIcon;
  return {
    label: {
      userSelect: 'none',
      cursor: 'pointer',
      display: 'inline-block',
      minWidth: x3,
      minHeight: x3,
      position: 'relative'
    },
    box: {
      display: 'inline-block',
      width: sizeControlCheckWidth,
      height: sizeControlCheckHeight,
      border: "1px solid " + colorBorder.normal,
      borderRadius: sizeBorderRadius,
      position: 'relative',
      marginRight: x2,
      verticalAlign: 'text-top',
      boxSizing: 'border-box',
      lineHeight: lineHeight,
      '& > svg': {
        visibility: 'hidden',
        position: 'absolute',
        left: '-1px',
        top: '-2px',
        fill: colorIcon.normal
      },
      '&:hover, &$hover': {
        borderColor: colorBorder.hover,
        '& > svg': {
          visibility: 'visible'
        }
      }
    },
    input: {
      display: 'none'
    },
    disabledLabel: {
      opacity: toneValueBase,
      cursor: 'not-allowed'
    },
    disabledBox: {
      background: colorBgSecondary.normal,
      borderColor: colorBorder.normal,
      '&:hover, &$hover': {
        borderColor: colorBorder.normal,
        '& > svg': {
          visibility: 'hidden'
        }
      }
    },
    activeBox: {
      background: colorPrimary.normal,
      border: 'none',
      '& > svg': {
        visibility: 'visible',
        fill: '#fff',
        left: '0',
        top: '-1px'
      }
    },
    activeDisabledBox: {
      background: colorBgSecondary.normal,
      borderColor: colorBorder.normal,
      '&:hover, &$hover': {
        borderColor: colorBorder.normal,
        '& > svg': {
          visibility: 'visible'
        }
      },
      '& > svg': {
        visibility: 'visible',
        fill: colorIcon.normal
      }
    },
    hover: {}
  };
};